<template>
  <input-widget type="select2" :attribute="attribute" :items="items" :search-handler="handler"
                display-field="${item.stock_no}" :value-field="valueField" :disabled="disabled" :hint="hint"
                :rules="rules"
                :model="model" :label="label" :options="computedOptions" @select2Select="onSelect"/>
</template>


<script>
  import InputWidget from "../components/input-widget/InputWidget";
  import InventoryService from "@/modules/inventory/InventoryService";
  import $ from 'jquery';

  /**
   * @author Saiat Kalbiev <kalbievich11@gmail.com>
   */
  export default {
    name: "InventorySelectInputWidget",
    components: {InputWidget},
    props: {
      model: {
        type: Object,
        required: true
      },
      attribute: {
        type: String,
        required: true
      },
      items: {
        type: Array,
        default: () => []
      },
      hint: {
        type: [Boolean, String],
        default: false
      },
      valueField: {
        type: String,
        default: 'uuid'
      },
      disabled: {
        type: Boolean,
        default: false
      },
      label: {
        type: [Boolean, String],
        default: null
      },
      options: {
        type: Object,
        default: () => {
          return null;
        }
      },
      rules: {
        type: String,
        default: null,
        required: false
      },
      withImage: {
        type: Boolean,
        default: false
      },
      expand: {
        type: String,
        default: ''
      }
    },
    computed: {
      computedOptions() {
        if (this.options) {
          return this.options
        }

        return {
          templateSelection: (item) => {
            let title = item.text

            if (item.id) {
              title = `${item.stock_no} - ${this.$options.filters.truncate(this.$options.filters.striptags(item.short_description))}`
            }

            return title;
          },
          templateResult: (item) => {
            let title = item.text

            if (item.id) {
              title = `${item.stock_no} - ${this.$options.filters.truncate(this.$options.filters.striptags(item.short_description))}`
            }

            if (this.withImage && item.images && item.images.length > 0 && item.images[0].data && item.images[0].data.thumb) {
              return $(`<span><img style="max-width: 50px;margin-right: 10px" src="${item.images[0].data.thumb.url}" class="img-flag" />${title}</span>`);

            }
            return title;
          }
        }
      }
    },
    methods: {
      handler(search) {
        let expand;
        if (this.withImage) {
          expand = [
              ...(this.expand ? this.expand.split(',') : []),
              'images'
          ]
        } else {
          expand = this.expand.split(',')
        }
        return InventoryService.getInventories({search, expand: expand.join(',')});
      },
      updateItems() {
        if (this.items.length) {
          return;
        }
        const uuid = this.attribute.substr(this.attribute.length - 5, 5);
        if (uuid === '_uuid') {
          let toListenAttribute = this.attribute.substr(0, this.attribute.length - 5);
          if (this.model[toListenAttribute]) {
            this.items.push(this.model[toListenAttribute]);
          }

          this.$watch(`model.${this.attribute}`, function () {
            if (this.model[toListenAttribute] && this.model[toListenAttribute].uuid === this.model[this.attribute]) {
              this.items.push(this.model[toListenAttribute]);
            } else if (!this.model[this.attribute]) {
              this.items.length = 0;
            }
          }, {deep: true});
        }
      },
      onSelect(data) {
        this.$emit('select', data);
      }
    },
    mounted() {
      this.updateItems();
    }
  }
</script>

<style scoped>

</style>
